const MatchRendering = function() {
    const stateMap = {
        1: 'Προγραμματισμένος',
        2: 'Παίζεται',
        3: 'Ημίχρονο',
        4: 'Τελείωσε',
        5: 'Διακοπή',
        6: 'Αναβολή',
        7: 'Παράταση / Πέναλτυ',
        8: 'Κρυμμένος'
    };

    return {
        updateScore: function(score) {
            let newContent = score;
            const scoreContainerSel = '.score-list-header__current strong';
            if ($(scoreContainerSel + ' sup').length) {
                newContent += '<sup>*</sup>';
            }
            $(scoreContainerSel).html(newContent);
        },

        updateStatus: function(state_id, currentMinute, injuryTimeElapsed) {
            let statusStr = stateMap[state_id];
            if (state_id == 1 && Generic.mobile) {
                statusStr = '';
            }
            let statusHtml = `<span>${statusStr}</span>`;
            if ([2, 7].indexOf(state_id) >= 0 && currentMinute >= 1 && currentMinute <= 120) {
                if (injuryTimeElapsed && [45, 90, 105, 120].indexOf(currentMinute) >= 0) {
                    currentMinute += '+' + injuryTimeElapsed;
                }
                statusHtml = `
                        <div class="live-minute">
                            <span>${currentMinute}'</span>
                            <div class="live-minute__bar"></div>
                        </div>
                    `;
            }
            $('.score-list-header__current .score-list-header__info').html(statusHtml);
        }
    };
}();
